"use client";

import { createContext, ReactNode, useContext, useState } from "react";
import { LiveChatWidget, EventHandlerPayload } from "@livechat/widget-react";

type LivechatContextType = {
  openLivechat: () => void;
  visibility: "maximized" | "minimized" | "hidden";
};

const LivechatContext = createContext<LivechatContextType | null>(null);

const LivechatProvider = ({ children }: { readonly children: ReactNode }) => {
  const [visibility, setVisibility] = useState<"maximized" | "minimized" | "hidden">("minimized");
  function handleNewEvent(event: EventHandlerPayload<"onNewEvent">) {
    // console.log("LiveChatWidget.onNewEvent", event);
  }

  const openLivechat = () => {
    setVisibility("maximized");
  };

  return (
    <LivechatContext.Provider value={{ openLivechat, visibility }}>
      <LiveChatWidget
        license="18919334"
        visibility={visibility}
        onNewEvent={handleNewEvent}
        onVisibilityChanged={(e) => {
          // console.log("onVisibilityChanged", e.visibility);
          // setVisibility(e.visibility === "minimized" ? "hidden" : e.visibility);
        }}
      />
      {children}
    </LivechatContext.Provider>
  );
};

const useLivechat = () => {
  const context = useContext(LivechatContext);
  if (!context) {
    throw new Error("useLivechat must be used within a LivechatProvider");
  }
  return context;
};

export { useLivechat, LivechatProvider };
